// eslint-disable-next-line import/prefer-default-export
export function round(value: number, precision: number): string {
  const multiplier = 10 ** (precision || 0);
  return (Math.round(value * multiplier) / multiplier).toFixed(precision);
}
